var __jsx = React.createElement;
import React from 'react';
// import Fab from '@material-ui/core/Fab';
import ClearIcon from '@mui/icons-material/Clear';
import VideocamIcon from '@mui/icons-material/Videocam';
import { getVideoId } from 'helpers';
import { VideoContainer, CloseBtn, LinkContainer, useClasses } from './style';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var getHeight = function getHeight(width) {
  return width * 45 / 80;
};
var VideoPreview = function VideoPreview(_ref) {
  var id = _ref.id,
    value = _ref.value,
    onRemoveClick = _ref.onRemoveClick,
    width = _ref.width;
  var classes = useClasses();
  var removeClickHandler = function removeClickHandler() {
    onRemoveClick(id);
  };
  var parsedValue = null;
  if (value) {
    var videoId = getVideoId(value);
    if (videoId && videoId.type === 'YOUTUBE') {
      parsedValue = /*#__PURE__*/_jsx("iframe", {
        className: classes.video,
        title: videoId.value,
        width: width,
        height: getHeight(width),
        src: "https://www.youtube.com/embed/".concat(videoId.value),
        frameBorder: "0",
        allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
      });
    } else if (videoId && videoId.type === 'VIMEO') {
      parsedValue = /*#__PURE__*/_jsx("iframe", {
        title: videoId.value,
        src: "https://player.vimeo.com/video/".concat(videoId.value),
        width: width,
        height: getHeight(width),
        frameBorder: "0",
        allow: "autoplay; fullscreen; picture-in-picture",
        allowFullScreen: true
      })
      // </div>
      ;
    }
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(VideoContainer, {
      fullWidth: !parsedValue,
      children: [parsedValue || /*#__PURE__*/_jsx(LinkContainer, {
        children: /*#__PURE__*/_jsxs("a", {
          href: value.indexOf('http') === 0 ? value : "http://".concat(value),
          target: "_blank",
          rel: "noopener noreferrer",
          children: [/*#__PURE__*/_jsx(VideocamIcon, {}), value]
        }, id)
      }), onRemoveClick && /*#__PURE__*/_jsx(CloseBtn, {
        size: "small",
        color: "primary",
        "aria-label": "Remove",
        onClick: removeClickHandler,
        children: /*#__PURE__*/_jsx(ClearIcon, {})
      })]
    })
  });
};
VideoPreview.defaultProps = {
  width: 400,
  onChange: undefined
};
export default VideoPreview;